import React from 'react';
import { observer } from 'mobx-react-lite';

const ExtraOptions = observer(
  ({
    withDriver,
    rightSideHelm,
    computer,
    centralOilManagement,
    conditioner,
    heaterInCabin,
    enginePreheater,
  }) => {
    const params = [
      withDriver && 'Аренда с водителем',
      rightSideHelm && 'Правый руль',
      computer && 'Бортовой компьютер',
      centralOilManagement && 'Центральная смазка',
      conditioner && 'Кондиционер',
      heaterInCabin && 'Автономный отопитель салона',
      enginePreheater && 'Предпусковой обогрев двиг.',
    ].filter((item) => item);

    return params.map((item, i) => (
      <tr key={i}>
        <td className={i === 0 ? 'transparent' : ''}>{i === 0 && 'Доп.'}</td>
        <td>{item}</td>
      </tr>
    ));
  },
);

export default ExtraOptions;
